import React from 'react';
import { Navigation } from '../components/Navigation';
import { Hero } from '../components/Hero';
import { PropertyOverview } from '../components/PropertyOverview';
import { GarageFeature } from '../components/GarageFeature';
import { BuyerPersonas } from '../components/BuyerPersonas';
import { LandFreedom } from '../components/LandFreedom';
import { LocationSection } from '../components/LocationSection';
import { AgentSection } from '../components/AgentSection';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
export function PropertyPage() {
  return <div className="min-h-screen bg-[#FAF8F5]" data-id="element-178">
      <Navigation data-id="element-179" />
      <main data-id="element-180">
        <Hero data-id="element-181" />
        <PropertyOverview data-id="element-182" />
        <GarageFeature data-id="element-183" />
        <BuyerPersonas data-id="element-184" />
        <LandFreedom data-id="element-185" />
        <LocationSection data-id="element-186" />
        <AgentSection data-id="element-187" />
        <CTASection data-id="element-188" />
      </main>
      <Footer data-id="element-189" />
    </div>;
}